import api from './api';

export interface ModuloDisponivel {
  codigo: string;
  nome: string;
}

export interface PerfilAdministrativo {
  id: number;
  codigo: string;
  nome: string;
  descricao?: string | null;
  acesso_total: boolean;
  ativo: boolean;
  modulos: string[];
  usuarios_vinculados: number;
}

// O codigo nao e enviado pela tela: o backend gera a partir do nome na criacao
// e preserva o codigo original na edicao.
export type DadosPerfil = {
  nome: string;
  descricao: string;
  acesso_total: boolean;
  ativo: boolean;
};

const base = '/api/v1/admin/perfis-administrativos';

export default {
  listar: async () => {
    const { data } = await api.get<{ perfis: PerfilAdministrativo[]; modulos_disponiveis: ModuloDisponivel[] }>(base);
    return data;
  },
  criar: async (perfil: DadosPerfil, modulos: string[]) =>
    (await api.post<{ perfil: PerfilAdministrativo }>(base, { perfil_administrativo: perfil, modulos })).data.perfil,
  atualizar: async (id: number, perfil: DadosPerfil, modulos: string[]) =>
    (await api.patch<{ perfil: PerfilAdministrativo }>(`${base}/${id}`, { perfil_administrativo: perfil, modulos })).data.perfil,
};
